module.exports = __webpack_public_path__ + "static/img/12.2af566b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/12.png
// module id = MnpH
// module chunks = 0